import type { ReactNode } from 'react';
import { cn } from './cn.js';

export interface PageHeaderProps {
  /** Kleine Zeile ueber dem Titel (z. B. Rubrik oder Datum). */
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ eyebrow, title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-5', className)}>
      <div className="min-w-0 flex-1">
        {eyebrow && (
          <div className="mb-1 text-xs uppercase tracking-wider text-text-muted">{eyebrow}</div>
        )}
        <h1 className="text-3xl font-semibold tracking-tight text-text leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1.5 text-sm text-text-dim">{subtitle}</p>
        )}
      </div>
      {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
    </div>
  );
}
